module.exports = __webpack_public_path__ + "static/media/asr_zindi.6cf52f0a.png";